export var WidgetType;
(function (WidgetType) {
    // Overview Tab
    WidgetType["FINANCIAL_OVERVIEW_CARD_1"] = "financial_overview_card_1";
    WidgetType["FINANCIAL_OVERVIEW_CARD_2"] = "financial_overview_card_2";
    WidgetType["FINANCIAL_OVERVIEW_CARD_3"] = "financial_overview_card_3";
    WidgetType["FINANCIAL_OVERVIEW_CARD_4"] = "financial_overview_card_4";
    WidgetType["WARRANTY_METRICS_CARD_1"] = "warranty_metrics_card_1";
    WidgetType["WARRANTY_METRICS_CARD_2"] = "warranty_metrics_card_2";
    WidgetType["WARRANTY_METRICS_CARD_3"] = "warranty_metrics_card_3";
    WidgetType["WARRANTY_METRICS_CARD_4"] = "warranty_metrics_card_4";
    WidgetType["FINANCE_SHIPPING_CARD_1"] = "finance_shipping_card_1";
    WidgetType["FINANCE_SHIPPING_CARD_2"] = "finance_shipping_card_2";
    WidgetType["FINANCE_SHIPPING_CARD_3"] = "finance_shipping_card_3";
    WidgetType["FINANCE_SHIPPING_CARD_4"] = "finance_shipping_card_4";
    WidgetType["FINANCE_SHIPPING_CARD_5"] = "finance_shipping_card_5";
    WidgetType["FINANCE_SHIPPING_CARD_6"] = "finance_shipping_card_6";
    WidgetType["AVERAGE_FUNDED_TO_DELIVERED"] = "average_funded_to_delivered";
    WidgetType["OUTSTANDING_OWED_CARD_1"] = "outstanding_owed_card_1";
    WidgetType["OUTSTANDING_OWED_CARD_2"] = "outstanding_owed_card_2";
    WidgetType["CHECKBOOK_AMOUNT"] = "checkbook_amount";
    WidgetType["VEHICLES_OWNED"] = "vehicles_owned";
    WidgetType["VEHICLES_OWNED_TOTAL_VALUE"] = "vehicles_owned_total_value";
    WidgetType["VEHICLES_FUNDED"] = "vehicles_funded";
    WidgetType["VEHICLES_FUNDED_TOTAL_VALUE"] = "vehicles_funded_total_value";
    WidgetType["VEHICLES_FUNDED_NOT_PAID_COUNTS"] = "vehicles_funded_not_paid_counts";
    WidgetType["VEHICLES_FUNDED_NOT_PAID_VALUES"] = "vehicles_funded_not_paid_values";
    WidgetType["VEHICLES_PENDING_SALE"] = "vehicles_pending_sale";
    WidgetType["PENDING_RETURNING_CAPITAL"] = "pending_returning_capital";
    /** Sum of estimated repair costs for vehicles in pending sale (Pending Sale / Active Deal). */
    WidgetType["PENDING_EXPECTED_REPAIR_COSTS"] = "pending_expected_repair_costs";
    /** Total unpaid repair expenses (Repairs category, not marked paid). */
    WidgetType["UNPAID_REPAIR_COSTS"] = "unpaid_repair_costs";
    WidgetType["EXPENSE_SUMMARY_TABLE"] = "expense_summary_table";
    WidgetType["RECENT_SALES_TABLE"] = "recent_sales_table";
    WidgetType["EXPECTED_VS_ACTUAL_REPAIR_CHART"] = "expected_vs_actual_repair_chart";
    WidgetType["SALES_OVERVIEW"] = "sales_overview";
    WidgetType["MONTHLY_COMPARISON"] = "monthly_comparison";
    WidgetType["CRM_USER_ACTIVITY"] = "crm_user_activity";
    /** Owner audit of transport-company $/mi and per-leg estimated shipping prices. */
    WidgetType["SHIPPING_PRICE_AUDIT"] = "shipping_price_audit";
    // Inventory Tab
    WidgetType["INVENTORY_OVERVIEW_TABLE"] = "inventory_overview_table";
    WidgetType["INVENTORY_METRICS_CARD_1"] = "inventory_metrics_card_1";
    WidgetType["INVENTORY_METRICS_CARD_2"] = "inventory_metrics_card_2";
    WidgetType["INVENTORY_METRICS_CARD_3"] = "inventory_metrics_card_3";
    WidgetType["INVENTORY_METRICS_CARD_4"] = "inventory_metrics_card_4";
    WidgetType["PAID_VEHICLES_GRID"] = "paid_vehicles_grid";
    // Sales Tab
    WidgetType["ACTIVE_DEALS"] = "active_deals";
    WidgetType["PENDING_DEALS"] = "pending_deals";
    WidgetType["FUNDED_NOT_SOLD"] = "funded_not_sold";
    WidgetType["MONTHLY_SALES_PERFORMANCE"] = "monthly_sales_performance";
    WidgetType["INVENTORY_WARRANTY"] = "inventory_warranty";
    /** Shared override code for Pending Sale on not-purchased trucks. */
    WidgetType["PENDING_SALE_OVERRIDE_CODE"] = "pending_sale_override_code";
    // Applications Tab
    WidgetType["FINANCING_APPLICATIONS"] = "financing_applications";
    // Repair Tab
    WidgetType["VEHICLES_IN_REPAIR_GRID"] = "vehicles_in_repair_grid";
    // Payroll Tab
    WidgetType["PAYROLL_OVERVIEW"] = "payroll_overview";
})(WidgetType || (WidgetType = {}));
export var DashboardTab;
(function (DashboardTab) {
    DashboardTab["OVERVIEW"] = "overview";
    DashboardTab["INVENTORY"] = "inventory";
    DashboardTab["SALES"] = "sales";
    DashboardTab["APPLICATIONS"] = "applications";
    DashboardTab["REPAIR"] = "repair";
    DashboardTab["PAYROLL"] = "payroll";
})(DashboardTab || (DashboardTab = {}));
export var ComponentVariant;
(function (ComponentVariant) {
    ComponentVariant["SALES_AND_DEALS_WITH_PROFIT"] = "sales_and_deals_with_profit";
    ComponentVariant["SALES_AND_DEALS_NO_PROFIT"] = "sales_and_deals_no_profit";
    ComponentVariant["SOLD_VEHICLES_OVERVIEW"] = "sold_vehicles_overview";
    ComponentVariant["PENDING_DEALS_WITH_PROFIT"] = "pending_deals_with_profit";
    ComponentVariant["PENDING_DEALS_NO_PROFIT"] = "pending_deals_no_profit";
    ComponentVariant["PENDING_DEALS_INDIVIDUAL"] = "pending_deals_individual";
    ComponentVariant["RECENT_SALES_WITH_PROFIT"] = "recent_sales_with_profit";
    ComponentVariant["RECENT_SALES_NO_PROFIT"] = "recent_sales_no_profit";
    ComponentVariant["SALES_OVERVIEW_WITH_PROFIT"] = "sales_overview_with_profit";
    ComponentVariant["SALES_OVERVIEW_NO_PROFIT"] = "sales_overview_no_profit";
    ComponentVariant["MONTHLY_COMPARISON_WITH_PROFIT"] = "monthly_comparison_with_profit";
    ComponentVariant["MONTHLY_COMPARISON_NO_PROFIT"] = "monthly_comparison_no_profit";
    ComponentVariant["STOCK_OVERVIEW_WITH_PROFIT"] = "stock_overview_with_profit";
    ComponentVariant["STOCK_OVERVIEW_NO_PROFIT"] = "stock_overview_no_profit";
    ComponentVariant["SALES_TREND_CHART_WITH_PROFIT"] = "sales_trend_chart_with_profit";
    ComponentVariant["SALES_TREND_CHART_NO_PROFIT"] = "sales_trend_chart_no_profit";
})(ComponentVariant || (ComponentVariant = {}));
